import { useEffect } from 'react';
import { SubmitFunction, Location } from 'react-router';
import { FullStory } from '@fullstory/browser';

function getUtmParam(searchParams: URLSearchParams, key: string) {
  return searchParams.get(key)?.slice(0, 40) || null;
}

interface FullstorySessionProps {
  fullstoryRecordingStarted: boolean;
  user_signed_in: boolean;
  account_id?: string;
  submit: SubmitFunction;
  location: Location;
}

export function useFullstorySession({
  fullstoryRecordingStarted,
  user_signed_in,
  account_id,
  submit,
  location,
}: FullstorySessionProps) {
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    if (fullstoryRecordingStarted) {
      if (user_signed_in && account_id) {
        FullStory('setIdentity', { uid: account_id });
      } else {
        FullStory('setIdentity', { anonymous: true });
      }

      const sessionId = FullStory('getSession', { format: 'id' });
      if (sessionId) {
        submit(
          {
            intent: 'fullstory-session',
            fullstory_session_id: sessionId,
            utm_source: getUtmParam(searchParams, 'utm_source'),
            utm_medium: getUtmParam(searchParams, 'utm_medium'),
            utm_campaign: getUtmParam(searchParams, 'utm_campaign'),
          },
          { method: 'post', navigate: false }
        );
      }
    }
  }, [fullstoryRecordingStarted, user_signed_in, account_id, submit, location.search]);
}
